import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { PHBHPFeaturePackageConfigurationService } from "../ph-bhp-feature-package-configuration.service";
import { PHBHPLayoutPackageService } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AppConfig } from "src/app/app.config";
import { TranslationKeys } from "ph-bhp-localization";
import { ProfessionalSubCategory } from "src/app/models/professional-sub-category";
import { CatalogMasterService } from "../../services/catalog-master.service";
import { ProfessionalCategory } from "src/app/models/professional-category";
import { Country } from "../../../../../../../Mobile/Observe/src/app/models/Country";
import { ProfessionalSubCategoryCountryConfiguration } from "../../models/professional-sub-category";
import { SubCategory } from "../../../../../../../Mobile/Observe/src/app/models/ProfessionalSubCategory";
import { ProfessionalSubCategoryDTO } from "src/app/models/professional-sub-category-dto";
import { User } from "../Models/Country";
import { ChangedTranslationValue } from "ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/dynamic-translation-dialog/dynamic-translation-dialog.component";
import { openTranslationModal } from "ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/translation.utilities";
import { LoggingService } from "src/app/services/logging.service";
import { trLocale } from "ngx-bootstrap/chronos";
import { error } from "console";
import { UserDataService } from "src/app/services/userData.service";

@Component({
  selector: "app-ph-bhp-configure-sub-category",
  templateUrl: "./ph-bhp-configure-sub-category.component.html",
  styleUrls: ["./ph-bhp-configure-sub-category.component.css"],
})
export class PhBhpConfigureSubCategoryComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  // gridData: SubCategory[];
  gridData: any;
  fields: any[];
  pageInfo: any;
  userData;
  modalRef: BsModalRef;
  searchText;
  deleteDataItem;
  deleterowIndex;
  categories: ProfessionalCategory[];
  subCategorySelected: ProfessionalSubCategoryDTO;
  subCategoryModelGridEdit: any;
  userSubjectSubscription: any;
  isCountryAdmin: boolean = false;
  addNewRow: boolean = true;
  institutionList: any[];
  checkedInstitutionIds = new Array<number>();
  selectAllChecked: boolean;
  searchTextInstitution: string = '';
  selectedIndex: number = 0;
  isInstitutionAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  @ViewChild('grid') grid: any;
  @ViewChild("delmodal") delmodal: TemplateRef<any>;
  @ViewChild("institutionsmodal") institutionsmodal: TemplateRef<any>;

  actionItems: any = [
    { name: 'CONFIGURE.SUBCATEGORY_VISIBILITY', imgSrc: 'assets/ph-bhp-layout/svg/icon-playlist-add.svg',
      onClick: (dataItem, rowIndex) => { return this.openInstitutionsModal(dataItem, rowIndex);},
      canShow: (dataItem) => { return dataItem.visibilityType == 'institutions' && this.appConfig.userData.roleName.roleId == 2}
    },
    { name: 'CONFIGURE.EDIT', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', isEdit: true },
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg',
      onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem);},
      canShow: (dataItem) => { return this.isRowDeletable(dataItem) && this.appConfig.userData.roleName.roleId == 2; }
    },
    { name: 'CONFIGURE.SUBCATEGORY_TRL', imgSrc: 'assets/ph-bhp-layout/svg/icon-trl.svg',
      onClick: (dataItem, rowIndex) => { return this.openTranslationModal(dataItem, rowIndex);},
      canShow: (dataItem) => { return this.appConfig.userData.roleName.roleId == 2;}
    }
  ];

  translationKeys: typeof TranslationKeys = TranslationKeys;


  constructor(
    private service: PHBHPFeaturePackageConfigurationService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public appConfig: AppConfig,
    private catalogMasterService: CatalogMasterService,
    private logging: LoggingService,

  ) { }

  ngOnInit() {
    this.isCountryAdmin = this.isUserCountryAdmin();
    this.getSubCategoryList();
    this.addNewRow = this.appConfig.userData.roleName.roleId != 4;
    this.isInstitutionAdmin = this.appConfig.userData.roleName.roleId == 4;
    this.isSuperAdmin = this.appConfig.userData.roleName.roleId == 1;
    this.fields = [
      {
        field: "subCategoryName",
        title: "CONFIGURE.PROFESSIONAL_SUB_CATEGORY",
        editTemplate: {
          type: "text",
          maxLength: 60,
          isDisabled: (subcategory: ProfessionalSubCategoryDTO): boolean => {
            return this.appConfig.userData.roleName.roleId == 4;
          },
        },
      },
      {
        field: "categoryName",
        title: "CONFIGURE.PROFESSIONAL_CATEGORY",
        editTemplate: {
          type: "dropdown",
          textField: "categoryName",
          valueField: "categoryID",
          isDisabled: (subcategory: ProfessionalSubCategoryDTO): boolean => {
            if(this.appConfig.userData.roleName.roleId == 4) return true;
            if (subcategory === undefined) return false;
            return subcategory.isUserDefined === false;
          },
        },

      },
      {
        field: "isEnabledForNewObservations",
        title: this.isInstitutionAdmin ? "CONFIGURE.PROFESSIONAL_SUB_CATEGORY_IS_ENABLED" : "CONFIGURE.PROFESSIONAL_SUB_CATEGORY_IS_ENABLED_FOR_NEW_OBSERVATIONS",
        editTemplate: {
          type: "checkbox",
          textField: "",
          valueField: "isEnabledForNewObservationsValue",
          isChecked: (subcategory: ProfessionalSubCategoryDTO) => {
            return ProfessionalSubCategoryDTO.isEnabledForNewObservations(subcategory)
          }
        },
      },
      {
        field: "visibility",
        title: "CONFIGURE.PROFESSIONAL_SUB_CATEGORY_VISIBILITY",
        editTemplate: {
          type: "dropdown",
          textField: "visibility",
          valueField: "visibilityType",
          data:[
            {visibilityType: 'country', visibility: 'CONFIGURE.COUNTRY'},
            {visibilityType: 'institutions', visibility: 'EVALUATION.INSTITUTION'}
          ],
          isDisabled: (dataItem): boolean => {
            if(this.appConfig.userData.roleName.roleId == 4) return true;
            return dataItem.isUserDefined === false;
          },
        },
      },
    ];

    if (this.isInstitutionAdmin) {
      this.fields = this.fields.filter(field => field.field !== 'visibility');
    }

    if (this.isSuperAdmin) {
      this.fields = this.fields.filter(field => field.field !== 'visibility' && field.field !== 'isEnabledForNewObservations');
    }

    this.pageInfo = {
      items: "CONFIGURE.PROFESSIONAL_SUB_CATEGORIES",
      itemsPerPageLabel: "CONFIGURE.PER_PAGE.PROFESSIONAL_SUB_CATEGORIES",
    };

    // tslint:disable-next-line:member-ordering
    this.subCategoryModelGridEdit = new UntypedFormGroup({
      subCategoryName: new UntypedFormControl(
        "",
        Validators.compose([Validators.required, Validators.maxLength(60)])
      ),
      categoryID: new UntypedFormControl(
        "",
        Validators.compose([Validators.required, Validators.maxLength(60)])
      ),
      isEnabledForNewObservations: new UntypedFormControl(
        { value: true, disabled: false },
        Validators.compose([])
      ),
    });

    this.subscription = this.layoutService.lang
      .asObservable()
      .subscribe((selectedLang) => {
        this.getSubCategoryList();
      });

    this.userSubjectSubscription = this.appConfig.userSubject
      .asObservable()
      .subscribe((res) => {
        this.isCountryAdmin = this.isUserCountryAdmin();
        if(this.appConfig.userData.roleName.roleId == 1){
          delete this.actionItems;
          this.addNewRow = false;
        }
        this.getSubCategoryList();
      });

     if(this.appConfig.userData ? this.appConfig.userData.roleName.roleId == 1 : true){
      delete this.actionItems;
      this.addNewRow = false;
     }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.userSubjectSubscription.unsubscribe();
  }

  changeGridLang() {
    this.gridData.forEach((value, index) => {
      this.gridData[index].subCategoryName = this.layoutService.translateText(
        value.subCategoryName
      );
    });
  }

  getSubCategoryList() {
    if (this.appConfig.userData) {

      this.layoutService.showLoader = true;
      this.catalogMasterService
        .getProfessionalSubCategoriesByCountry(this.appConfig.userData.country)
        .subscribe((res: ProfessionalSubCategoryDTO[]) => {
          this.layoutService.showLoader = false;
          let that = this;
          this.gridData = res.filter(inst => this.filterSubCategories(inst, this.appConfig.userData.roleName.roleId)).map(item => this.manageGrid(item, that));;
          this.changeGridLang();
        });

      this.catalogMasterService
        .getProfessionalCategories()
        .subscribe((res: ProfessionalCategory[]) => {
          this.categories = res;

          this.fields[1].editTemplate.data = res;
          this.changeLangForSubCategory();
        });
    }
  }

  changeLangForSubCategory() {
    this.fields[1].editTemplate.data.forEach((value, index) => {
      value.categoryName = this.layoutService.translateText(value.categoryName);
    });
  }

  handlerData({ handler, formGroup, isNew, dataItem, rowIndex }): void {
    this.userData = this.appConfig.userData;
    let currentSubcategory: ProfessionalSubCategoryDTO = dataItem;

    switch (handler) {
      case "saveHandler":
        var userId = this.userData.userId;
        var subcategoryFormData: any = dataItem;
        // change isEnabledForNewObservationsValue to isEnabledForNewObservations return from table dropdown
        subcategoryFormData.isEnabledForNewObservations = subcategoryFormData.isEnabledForNewObservationsValue
        if (isNew) {
          var newSubcategory: ProfessionalSubCategory = {
            subCategoryID: 0,
            categoryID: subcategoryFormData.categoryID,
            createdBy: userId,
            countryID: +this.appConfig.userData.country,
            isUserDefined: true,
            subCategoryName: subcategoryFormData.subCategoryName,
            professionalSubCategoryCountryConfigurations: [
              {
                professionalSubCategoryCountryConfigurationID: 0,
                countryID: +this.appConfig.userData.country,
                isEnabledForNewObservations:
                  subcategoryFormData.isEnabledForNewObservations !== null
                    ? subcategoryFormData.isEnabledForNewObservations
                    : true,
                subCategoryName: subcategoryFormData.subCategoryName,
                visibilityType: subcategoryFormData?.visibilityType || 'country',
                professionalSubcategoriesTranslations:[{
                  professionalSubCategoryCountryConfigurationID: 0,
                  lang: this.translate.currentLang,
                  translation: subcategoryFormData.subCategoryName
                }],
                professionalSubCategoriesVisibility:[],
                professionalSubcategoriesEnabilityByIA:[]
              },
            ],
          };
          this.service
            .createSubCategory(newSubcategory)
            .subscribe((res: ProfessionalSubCategory) => {
              // this.layoutService.showSuccess(
              //   this.layoutService.translateText(
              //     "CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.PROFESSIONAL_SUB_CATEGORY"
              //   )
              // );
              this.getSubCategoryList();
            },error => {
              this.getSubCategoryList();
            });
        } else {
          let enability;
          let enabledForNewObservations;

          if(this.appConfig.userData.roleName.roleId == 4){
            enabledForNewObservations = currentSubcategory.professionalSubCategoryCountryConfiguration
            ? currentSubcategory.professionalSubCategoryCountryConfiguration.isEnabledForNewObservations
            : currentSubcategory.isUserDefined === false;

            const selectedInstitution = localStorage.getItem('selectedInstitution');
            if(currentSubcategory.professionalSubCategoryCountryConfiguration?.professionalSubcategoriesEnabilityByIA?.length > 0){
              enability = currentSubcategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.find(element => {
                return element.institutionId == (+selectedInstitution);
              });
              if(enability){
                enability.isEnabledForNewObservations = subcategoryFormData.isEnabledForNewObservationsValue
              }else{
                enability = {
                  professionalSubCategoryCountryConfigurationID: (currentSubcategory.professionalSubCategoryCountryConfiguration
                    ? currentSubcategory.professionalSubCategoryCountryConfiguration.professionalSubCategoryCountryConfigurationID : 0),
                  institutionId: selectedInstitution,
                  isEnabledForNewObservations: subcategoryFormData.isEnabledForNewObservationsValue
                };
              }
            }else{
              enability = {
                professionalSubCategoryCountryConfigurationID: (currentSubcategory.professionalSubCategoryCountryConfiguration
                  ? currentSubcategory.professionalSubCategoryCountryConfiguration.professionalSubCategoryCountryConfigurationID : 0),
                institutionId: selectedInstitution,
                isEnabledForNewObservations: subcategoryFormData.isEnabledForNewObservationsValue
              };
            }
          }else{
            enabledForNewObservations = subcategoryFormData.isEnabledForNewObservations !== undefined  ? subcategoryFormData.isEnabledForNewObservations
            : (currentSubcategory.professionalSubCategoryCountryConfiguration
            ? currentSubcategory.professionalSubCategoryCountryConfiguration.isEnabledForNewObservations
            : currentSubcategory.isUserDefined === false);
          }

          var translations = currentSubcategory.professionalSubCategoryCountryConfiguration?.professionalSubcategoriesTranslations;
          if (!translations) {
            translations = [{
              professionalSubCategoryCountryConfigurationID: subcategoryFormData.professionalSubCategoryCountryConfigurationID || 0,
              lang: this.translate.currentLang,
              translation: subcategoryFormData.subCategoryName
            }];
          } else {
            var currentLanguageTranslation = {
              professionalSubCategoryCountryConfigurationID: subcategoryFormData.professionalSubCategoryCountryConfigurationID || 0,
              lang: this.translate.currentLang,
              translation: subcategoryFormData.subCategoryName
            };

            var index = translations.findIndex(
              (translation) => translation.lang == this.translate.currentLang
            );

            if (index > -1) {
              translations[index] = currentLanguageTranslation;
            } else {
              translations.push(currentLanguageTranslation);
            }
          }

          var updateSubcategory: ProfessionalSubCategoryDTO = {
            categoryID: subcategoryFormData.categoryID,
            subCategoryID: currentSubcategory.subCategoryID,
            subCategoryName: currentSubcategory.subCategoryName,
            isUserDefined: currentSubcategory.isUserDefined,
            countryID: currentSubcategory.countryID,
            professionalSubCategoryCountryConfiguration: {
              professionalSubCategoryCountryConfigurationID:
                currentSubcategory.professionalSubCategoryCountryConfiguration
                  ? currentSubcategory
                    .professionalSubCategoryCountryConfiguration
                    .professionalSubCategoryCountryConfigurationID
                  : 0,
              countryID: +this.appConfig.userData.country,
              isEnabledForNewObservations: enabledForNewObservations,
              subCategoryName: subcategoryFormData.subCategoryName,
              professionalSubcategoriesTranslations: translations,
              visibilityType: subcategoryFormData.visibilityType,
              professionalSubCategoriesVisibility: currentSubcategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility,
              professionalSubcategoriesEnabilityByIA: (this.appConfig.userData.roleName.roleId == 4 ?
              [enability] : currentSubcategory.professionalSubCategoryCountryConfiguration?.professionalSubcategoriesEnabilityByIA)
            },
          };

          this.service
            .updateSubCategory(
              currentSubcategory.subCategoryID,
              updateSubcategory
            )
            .subscribe((res: ProfessionalSubCategory) => {
              this.gridData[rowIndex].subCategoryName =
                subcategoryFormData.subCategoryName;
              // this.layoutService.showSuccess(
              //   this.layoutService.translateText(
              //     "CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.PROFESSIONAL_SUB_CATEGORY"
              //   )
              // );
              this.getSubCategoryList();
            },error => {
              this.getSubCategoryList();
            });
        }
        break;
      case "removeHandler":
        break;
    }
  }
  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem;
    this.modalRef = this.modalService.show(
      deletemodal,
      Object.assign({}, { class: 'w-420' })
    );
  }
  delete() {
    this.service
      .deleteSubCategory(this.deleteDataItem.subCategoryID)
      .subscribe((res: ProfessionalSubCategory) => {
        this.getSubCategoryList();
      });
  }

  isRowEditable(subcategory: ProfessionalSubCategory): boolean {
    return true;
  }

  isRowDeletable(subcategory: ProfessionalSubCategory): boolean {
    return subcategory && subcategory.isUserDefined;
  }

  translationEnabled(subCategory: ProfessionalSubCategory): boolean {
    return subCategory && !subCategory.isUserDefined
  }

  isUserCountryAdmin(): boolean {
    return this.appConfig.userData ? this.appConfig.userData.roleName.roleId == 2 : false
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  addRow() {
    this.grid.addRow();
  }

  openTranslationModal(subCategory: ProfessionalSubCategoryDTO, rowIndex: number) {
    const langId = this.translate.currentLang;
    const subCategoryID = ''+subCategory.subCategoryID;
    let translations = {};
    if(subCategory.professionalSubCategoryCountryConfiguration?.professionalSubcategoriesTranslations?.length > 0){
      subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesTranslations.forEach(element => {
        translations[element.lang] = element.translation;
      });
    }else{
      if(!subCategory.professionalSubCategoryCountryConfiguration){
        subCategory.professionalSubCategoryCountryConfiguration = {
          professionalSubCategoryCountryConfigurationID: 0,
          countryID: +this.appConfig.userData.country,
          isEnabledForNewObservations: true,
          subCategoryName: subCategory.subCategoryName,
          visibilityType: subCategory.isUserDefined ? 'country' : 'all',
          professionalSubcategoriesTranslations:[],
          professionalSubCategoriesVisibility:[],
          professionalSubcategoriesEnabilityByIA:[],
        }
      }

      // translations[langId] = subCategory.subCategoryName;
    }
      const modalRef = openTranslationModal(this.modalService, subCategoryID, translations, subCategory.subCategoryName, false, 200);
      let subCategoryToTranslate = subCategory;
      modalRef.content.subject$.subscribe((data: ChangedTranslationValue[]) => {



        data.forEach(newTrl => {
          let translation = subCategoryToTranslate.professionalSubCategoryCountryConfiguration
          .professionalSubcategoriesTranslations.find(trl => trl.lang == newTrl.language);
          if(!translation){
            translation = {
              professionalSubCategoryCountryConfigurationID: subCategoryToTranslate.professionalSubCategoryCountryConfiguration.professionalSubCategoryCountryConfigurationID,
              lang: newTrl.language,
              translation: newTrl.value
            }
            subCategoryToTranslate.professionalSubCategoryCountryConfiguration
            .professionalSubcategoriesTranslations.push(translation);
          }else{
            translation.translation = newTrl.value;
          }
        });

        this.service
        .updateSubCategory(
          subCategoryToTranslate.subCategoryID,
          subCategoryToTranslate
        )
        .subscribe((res: ProfessionalSubCategory) => {
          this.gridData[rowIndex].subCategoryName =
          subCategoryToTranslate.subCategoryName;
          // this.layoutService.showSuccess(
          //   this.layoutService.translateText(
          //     "CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.PROFESSIONAL_SUB_CATEGORY"
          //   )
          // );
          this.getSubCategoryList();
        });

      }, error => {
        this.logging.logError(error.message, error);
        this.layoutService.showLoader = false;
      });
  }

  openInstitutionsModal(subCategory: ProfessionalSubCategoryDTO, rowIndex: number) {

    this.layoutService.showLoader = true;
    this.subCategorySelected = subCategory;
    this.selectedIndex = rowIndex;
    this.checkedInstitutionIds = [];

    if(subCategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility?.length > 0){
      subCategory.professionalSubCategoryCountryConfiguration.professionalSubCategoriesVisibility.forEach(element => {
        this.checkedInstitutionIds.push(element.institutionId);
      });
    }else{
      if(!subCategory.professionalSubCategoryCountryConfiguration){
        subCategory.professionalSubCategoryCountryConfiguration = {
          professionalSubCategoryCountryConfigurationID: 0,
          countryID: +this.appConfig.userData.country,
          isEnabledForNewObservations: true,
          subCategoryName: subCategory.subCategoryName,
          visibilityType: subCategory.isUserDefined ? 'country' : 'all',
          professionalSubcategoriesTranslations:[],
          professionalSubCategoriesVisibility:[],
          professionalSubcategoriesEnabilityByIA:[]
        }
      }else if(!subCategory.professionalSubCategoryCountryConfiguration.professionalSubCategoriesVisibility){
        subCategory.professionalSubCategoryCountryConfiguration.professionalSubCategoriesVisibility = [];
      }
      this.checkedInstitutionIds = [];
    }

    this.service.getUsersInstitutions(this.appConfig.userData.userId, this.appConfig.userData.roleName.roleId).subscribe((res) => {
      this.institutionList = res;
      if (this.institutionList && this.institutionList.length > 0) {
        const roleId = this.appConfig.userData.roleName.roleId;
        this.institutionList = this.institutionList.filter(inst => roleId > 2 ? inst.institution.institution.status : true);
        this.institutionList.sort((a, b) => {
          if ((this.checkedInstitutionIds.includes(a.institution.institution.institutionID) === this.checkedInstitutionIds.includes(b.institution.institution.institutionID))) {
              return a.institution.institution.institutionName.localeCompare(b.institution.institution.institutionName);
          }
          if (this.checkedInstitutionIds.includes(a.institution.institution.institutionID)) {
              return -1;
          }
          return 1;
        });
        this.layoutService.showLoader = false;
        this.modalRef = this.modalService.show(this.institutionsmodal, Object.assign({}, { class: "institutionsVisibility w-420" }));
      }else{
        this.layoutService.showLoader = false;
      }
    }, error=>{
      this.layoutService.showLoader = false;
    });
  }

  manageGrid(item, that) {
    if (this.appConfig.userData.roleName.roleId == 4 && item.professionalSubCategoryCountryConfiguration?.professionalSubcategoriesEnabilityByIA?.length > 0) {
      const selectedInstitution = localStorage.getItem('selectedInstitution');
      let enability = item.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.find(element => {
        return element.institutionId == selectedInstitution;
      });
      item.isEnabledForNewObservationsValue = enability ? enability.isEnabledForNewObservations : (item.professionalSubCategoryCountryConfiguration?.isEnabledForNewObservations || false);
      item.isEnabledForNewObservations = (item.isEnabledForNewObservationsValue) ? that.layoutService.translateText('CONFIGURE.ENABLED') : that.layoutService.translateText('CONFIGURE.DISABLED');

    } else if (!item.isUserDefined && !item.professionalSubCategoryCountryConfiguration) {
      item.isEnabledForNewObservationsValue = true;
      item.isEnabledForNewObservations = 'CONFIGURE.ENABLED';
    } else {
      item.isEnabledForNewObservationsValue = item.professionalSubCategoryCountryConfiguration?.isEnabledForNewObservations || false;
      item.isEnabledForNewObservations = (item.isEnabledForNewObservationsValue) ? that.layoutService.translateText('CONFIGURE.ENABLED') : that.layoutService.translateText('CONFIGURE.DISABLED');
    }

    if (item.professionalSubCategoryCountryConfiguration?.professionalSubcategoriesTranslations?.length > 0) {
      let translation = item.professionalSubCategoryCountryConfiguration.professionalSubcategoriesTranslations.find(element => {
        return element.lang == that.translate.currentLang;
      });

      let translationExist = translation && translation.translation.length > 0;

      if (this.isInstitutionAdmin) {
        item.subCategoryName = translationExist ? translation.translation : (item.isUserDefined ? item.professionalSubCategoryCountryConfiguration.subCategoryName : item.subCategoryName);
      } else {
        item.subCategoryName = item.isUserDefined ? item.professionalSubCategoryCountryConfiguration.subCategoryName : (translationExist? translation.translation : item.subCategoryName);
      }

    } else if (!this.isSuperAdmin) {
        item.subCategoryName = item.isUserDefined ? item.professionalSubCategoryCountryConfiguration.subCategoryName : item.subCategoryName;
    }

    item.categoryName = item.professionalCategory.categoryName;
    item.visibilityType = item.professionalSubCategoryCountryConfiguration?.visibilityType ? item.professionalSubCategoryCountryConfiguration.visibilityType : 'all';
    if (item.visibilityType == 'all') {
      item.visibility = 'DASHBOARD.ALL';
    } else if (item.visibilityType == 'country') {
      item.visibility = 'CONFIGURE.COUNTRY';
    } else {
      item.visibility = 'EVALUATION.INSTITUTION';
    }

    return item;
  }

  get checkedInstitutionIdsArray() {
    return Array.from(this.checkedInstitutionIds);
  }

  saveVisibility(){
    this.layoutService.showLoader = true;

    this.subCategorySelected.professionalSubCategoryCountryConfiguration.professionalSubCategoriesVisibility = [];

    this.checkedInstitutionIds.forEach(institutionId => {
        let visibleInstitution = {
          professionalSubCategoryCountryConfigurationID: this.subCategorySelected.professionalSubCategoryCountryConfiguration.professionalSubCategoryCountryConfigurationID,
          institutionId: institutionId
        }
        this.subCategorySelected.professionalSubCategoryCountryConfiguration
        .professionalSubCategoriesVisibility.push(visibleInstitution);
    });

    this.service.updateSubCategory(this.subCategorySelected.subCategoryID,this.subCategorySelected).subscribe((res: ProfessionalSubCategory) => {
      this.gridData[this.selectedIndex].subCategoryName =
      this.subCategorySelected.subCategoryName;
      this.layoutService.showSuccess(
        this.layoutService.translateText(
          "CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.PROFESSIONAL_SUB_CATEGORY"
        )
      );
      this.getSubCategoryList();
    });
    this.cleanSearch();
  }

  checkAll(ev) {
    const checked = ev.target.checked;

    if (checked) {
      this.checkedInstitutionIds = this.institutionList
        .filter(i => !i.institution.institution.isGroup)
        .map(i => i.institution.institution.institutionID)
    } else {
      // checkbox was toggled off: deselect all options
      this.checkedInstitutionIds = []
    }
    this.institutionList = this.institutionList.sort((a, b) => a.institution.institution.institutionName.localeCompare(b.institution.institution.institutionName))

  }

  checkOne(ev, institutionId: number) {
    const checked = ev ? ev.target.checked : false;

    if (checked) {
      this.checkedInstitutionIds = [...this.checkedInstitutionIds, institutionId];

    } else {
     this.checkedInstitutionIds =
        this.checkedInstitutionIds
          .filter(id => id != institutionId);
      if (this.selectAllChecked) {
        this.selectAllChecked = false;
      }
    }

    this.institutionList.sort((a, b) => {
      if ((this.checkedInstitutionIds.includes(a.institution.institution.institutionID) === this.checkedInstitutionIds.includes(b.institution.institution.institutionID))) {
          return a.institution.institution.institutionName.localeCompare(b.institution.institution.institutionName);
      }
      if (this.checkedInstitutionIds.includes(a.institution.institution.institutionID)) {
          return -1;
      }
        return 1;
    });
  }

  isChecked(institutionID: number) {
    return this.checkedInstitutionIds.includes(institutionID)
  }

  getInstitutionName(institutionId) {
    return this.institutionList.find(i => i.institution.institution.institutionID === institutionId).institution.institution.institutionName;
  }

  cleanSearch(){
    delete this.searchTextInstitution;
  }

  filterSubCategories(subCategory: ProfessionalSubCategoryDTO, roleId): boolean {
    if (roleId == 1) return subCategory.professionalSubCategoryCountryConfiguration?.visibilityType == 'all';

    if (roleId != 4) {
      return true;
    }

    // remove the disabled subcategories
    if (subCategory.professionalSubCategoryCountryConfiguration?.isEnabledForNewObservations == false) {
      return false;
    } else if (subCategory.professionalSubCategoryCountryConfiguration?.visibilityType == 'country') { // check by country
      return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.appConfig.userData.country);
    } else if (subCategory.professionalSubCategoryCountryConfiguration?.visibilityType == 'institutions') { // check by institution
      return subCategory.professionalSubCategoryCountryConfiguration.professionalSubCategoriesVisibility.some(element => {
        return element.institutionId == (+localStorage.getItem('selectedInstitution'));
      });
    }

    // else the global subcategories
    return true;
  }

}
